import React from "react"

import { Wrapper, Title, Expert } from "./styles"

const Review = ({ author, reviewer }) => {
  const { name: authorName, credentials: authorCredentials, url: authorUrl } = author || {}
  const { name: reviewerName, credentials: reviewerCredentials, url: reviewerUrl } = reviewer || {}

  const hasContent = authorCredentials || reviewerCredentials
  if (!hasContent) {
    return null
  }

  return (
    <Wrapper>
      <Title>Meet The Experts</Title>
      {authorCredentials && (
        <Expert
          dangerouslySetInnerHTML={{
            __html: authorCredentials.replace(
              authorName,
              `<a class="review-author-name" href="/wc/${authorUrl}">${authorName}</a>`,
            ),
          }}
        />
      )}
      {reviewerCredentials && (
        <Expert
          dangerouslySetInnerHTML={{
            __html: reviewerCredentials.replace(
              reviewerName,
              `<a class="review-author-name" href="/wc/${reviewerUrl}">${reviewerName}</a>`,
            ),
          }}
        />
      )}
    </Wrapper>
  )
}

export default Review
